import { SET_SUMMARY } from "./types";

export const setSummary = (salesSummary) => {
  return {
    type: SET_SUMMARY,
    salesSummary,
  };
};
